export default "__VITE_ASSET__CvZ9lYp1__"